export default "__VITE_ASSET__b3fef6a7__"